import React from "react";
import PropTypes from 'prop-types';
import Downshift from "downshift";
import cx from "classnames";
import {Icon} from "spectre-react/dist/cjs";
import {GroupedSelectMenu, PlainSelectMenu} from "./menu";
import {escapeRegexCharacters} from "../utils";


class MultiSelect extends React.PureComponent {
    static propTypes = {
        items: PropTypes.array,
        itemToString: PropTypes.func,
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        selectedItems: PropTypes.arrayOf(PropTypes.object),
        onChange: PropTypes.func.isRequired,
        searchable: PropTypes.bool,
        clearable: PropTypes.bool,
        grouped: PropTypes.bool,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        items: [],
        itemToString: (obj) => (obj ? obj.label : ''),
        selectedItems: [],
        searchable: false,
        clearable: true,
        grouped: false,
        disabled: false,
        placeholder: 'Select...'
    };

    stateReducer = (state, changes) => {
        switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
                return {...changes, inputValue: ''};
            default:
                return changes
        }
    };

    _onChange = (value) => this.props.onChange({target: {name: this.props.name, value}});

    handleSelection = (selectedItem) => {
        /*if (this.state.selectedItems.includes(selectedItem)) {*/
        const index = this.props.selectedItems.findIndex(i => i._id === selectedItem._id);
        if (index !== -1)
            this.removeItemAtIndex(index);
        else
            this.addItem(selectedItem);
    };

    removeItemAtIndex = (index) => {
        const selectedItems = this.props.selectedItems.slice();
        selectedItems.splice(index, 1);
        this._onChange(selectedItems);
    };
    addItem = (item) => this._onChange([...this.props.selectedItems, item]);

    onItemRemove = (ev) => {
        ev.stopPropagation();
        const index = parseInt(ev.target.dataset.index, 10);
        this.removeItemAtIndex(index);
    };

    clearSelectedItems = () => this._onChange([]);

    getItems = (inputValue) => {
        if (!inputValue) return this.props.items;
        const escapedValue = escapeRegexCharacters(inputValue.trim());
        if (escapedValue === '') return this.props.items;

        const re = new RegExp(escapedValue, 'i');
        const itemToString = this.props.itemToString;

        if (this.props.grouped)
            return this.props.items
                .map(section => ({
                    label: section.label,
                    items: section.items.filter(item => re.test(itemToString(item)))
                }))
                .filter(section => section.items.length > 0);
        else
            return this.props.items.filter(item => re.test(itemToString(item)));
    };

    renderChip = (item, index) => {
        return (
            <div key={item._id} className="chip">
                <button type="button" className="btn btn-clear" data-index={index} onClick={this.onItemRemove}/>
                {this.props.itemToString(item)}
            </div>
        )
    };

    render() {
        const {placeholder, itemToString, name, clearable, searchable, disabled} = this.props;
        const id = this.props.id || name;
        const selectedItems = this.props.selectedItems;
        const Menu = this.props.grouped ? GroupedSelectMenu : PlainSelectMenu;

        return (
            <Downshift stateReducer={this.stateReducer} onChange={this.handleSelection}
                       itemToString={itemToString} selectedItem={null}>
                {({
                      getMenuProps, getInputProps, getItemProps,
                      isOpen, inputValue, highlightedIndex, toggleMenu
                  }) => {
                    const matchingItems = this.getItems(inputValue);

                    return (
                        <div className="form-autocomplete custom-multiselect">
                            <div className={cx("form-autocomplete-input", "form-input", {'is-focused': isOpen})}>
                                {selectedItems.map(this.renderChip)}

                                <input {...getInputProps({
                                    onKeyDown: (ev) => {
                                        if (ev.key === 'Backspace' && !inputValue)
                                            this.removeItemAtIndex(-1);
                                    },
                                    onClick: toggleMenu,
                                    id, name, className: "form-input", readOnly: !searchable, disabled,
                                    placeholder: (selectedItems.length === 0) ? placeholder : '',
                                })}
                                />

                                {(selectedItems.length > 0) && clearable
                                    ? <Icon formIcon icon="cross"
                                            onClick={disabled ? undefined : this.clearSelectedItems}/>
                                    : <Icon formIcon icon={isOpen ? "arrow-up" : "arrow-down"}/>}
                            </div>

                            {isOpen && matchingItems.length > 0 &&
                                <Menu matchingItems={matchingItems} getMenuProps={getMenuProps}
                                      getItemProps={getItemProps}
                                      highlightedIndex={highlightedIndex} selectedItems={selectedItems}
                                      itemToString={itemToString}
                                      multi={true}
                                />}
                        </div>
                    );
                }}
            </Downshift>
        )
    }
}


export default MultiSelect;